/**
 * Copyright © 2025 Delicious AI, LLC
 *
 * @author Mitch Wilson <mitchell.wilson@deliciousai.com>
 */

import { gql } from '@apollo/client'

import { INVITATION_FRAGMENT } from '../fragments'

export const SEND_INVITATION = gql`
  mutation SendInvitation($data: CreateInvitationInput!) {
    sendInvitation(data: $data) {
      ...Invitation
    }
  }
  ${INVITATION_FRAGMENT}
`
